<template>

  <div class="form-group">
    <div style="display: flex; justify-content: center;">
      <el-button v-if="form.phones.bank_phone_id==0||!form.phones.bank_phone_id" @click.stop="openchoosephone">選擇並綁定已有的電話卡</el-button>
      <el-button v-if="form.phones.bank_phone_id>0" @click="unassociation" type="danger">取消已綁定的電話卡</el-button>
      <el-dialog @closed="closechoosephone" title="選擇已有的電話卡" :visible.sync="choosephone" width="95%" :append-to-body="true">
        <component @closephone="closephone" :is="choosephone_component"></component>
      </el-dialog>
    </div>
    <div class="form-group-content">
      <div class="mm-row">
				<div class="mm-col">
					<el-form-item label="代號" prop="phones.code">
						<el-input :disabled="form.phones.bank_phone_id>0" v-model="form.phones.code"></el-input>
					</el-form-item>
				</div>
			</div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="電話卡號碼" prop="phones.phone">
            <el-input :disabled="form.phones.bank_phone_id>0" v-model="form.phones.phone"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="網絡提供商" prop="phones.service">
            <el-input :disabled="form.phones.bank_phone_id>0" v-model="form.phones.service"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="電話卡到期日" prop="phones.endtime">
            <el-date-picker :disabled="form.phones.bank_phone_id>0" type="date" placeholder="選擇日期" v-model="form.phones.endtime" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="電話卡餘額" prop="phones.money">
            <el-input :disabled="form.phones.bank_phone_id>0" v-model="form.phones.money"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="備註" prop="phones.remarks">
            <el-input :disabled="form.phones.bank_phone_id>0" v-model="form.phones.remarks"></el-input>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import choosephone from './ChoosePhone.vue';
export default {
  components: {
    choosephone
  },
  props: ['form'],
  data () {
    return {
      choosephone: false,
      choosephone_component: '',
    };
  },
  methods: {

    closephone (phone) {
      this.choosephone = false;
      this.choosephone_component = '';
      this.form.phones.bank_phone_id = phone.id;
      this.form.phones.code = phone.code;
      this.form.phones.phone = phone.phone;
      this.form.phones.service = phone.service;
      this.form.phones.endtime = phone.endtime;
      this.form.phones.money = phone.money;
      this.form.phones.remarks= phone.remarks;
    },
    unassociation () {
      this.form.phones.bank_phone_id = 0;
      this.form.phones.code = '';
      this.form.phones.phone = '';
      this.form.phones.service = '';
      this.form.phones.endtime = '';
      this.form.phones.money = '';
      this.form.phones.remarks= '';
    },
    closechoosephone () {
      this.choosephone = false;
      this.choosephone_component = '';
    },
    openchoosephone () {
      this.choosephone = true;
      this.choosephone_component = choosephone;
    },

  }

};
</script>

<style>
</style>
